import { render, staticRenderFns } from "./ShowcaseRecordingsAdmin.vue?vue&type=template&id=f533f6cc&scoped=true"
import script from "./ShowcaseRecordingsAdmin.vue?vue&type=script&lang=js"
export * from "./ShowcaseRecordingsAdmin.vue?vue&type=script&lang=js"
import style0 from "./ShowcaseRecordingsAdmin.vue?vue&type=style&index=0&id=f533f6cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f533f6cc",
  null
  
)

export default component.exports